// extracted by mini-css-extract-plugin
export var actionIcon = "_ol-0";